import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';

export const NavItem = styled.li`
  width: 100%;
  transition: all 0.5s linear;

  @media (min-height: 600px) {
    &:last-child {
      position: absolute;
      bottom: 20px;
      left: 0;
    }
  }
`;

export const NavLink = styled(Link)`
  text-decoration: none;
  color: #fff;
  padding: 10px 23px;
  gap: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    background-color: #edd26f;
  }
`;

export const NavTitle = styled.h1`
  visibility: hidden;
  font-size: 1.4rem;
  font-family: 'GothamBold';
  white-space: nowrap;
`;
